$(document).ready(function(){
  
  // cart icon bubble update on document click
    $(document).on('click', function(){
      console.log('clicked');
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart) {
            $('.cart-count-bubble > span').text(cart.item_count);
        });
      }, 1000);
    });

  // page reload when someone goes back from product page
  window.addEventListener("pageshow", function(event) {
    var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
    if (historyTraversal) {
      var previousUrl = window.location.href;
      var productPagePattern = '/products/';
      if (previousUrl.includes(productPagePattern)) {
          location.reload();
      }
    }
  });

  // Open external link in new tab
  function externalLinks() {
    for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
      var b = c[a];
      b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank")
    }
  };
  externalLinks();
  
  // Check if there is a referrer
  if (document.referrer) {
    var previousPageLink = document.referrer;
    $(document).find('.go_back').attr('href', previousPageLink);
  }
  
   //Swiper Reviews Slider
   var swiper = new Swiper(".main_reviews", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
      nextEl: ".rev_arrows .swiper-button-next",
      prevEl: ".rev_arrows .swiper-button-prev",
    },
    pagination: {
      el: ".main_reviews .swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      850: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
  });

  
  // product card slider
  function hover_function(){
    var hover_swiper = new Swiper(".card_media_hover", {
        slidesPerView: 1,
        spaceBetween: 0,
        // scrollbar: {
        //   el: ".card_media_hover .swiper-scrollbar",
        //   hide: false,
        // },
        pagination: {
          el: ".card_media_hover .swiper-scrollbar",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".card_media_hover .swiper-button-next",
          prevEl: ".card_media_hover .swiper-button-prev",
        }
      });
      

  // Slider height
    slide_height();
    function slide_height(){
      $('.guineaDad .card-wrapper .card__inner').on('mouseenter', function(){
        var slide_width = $(this).find('.card_media_hover').width();
        $(this).find('.card_media_hover').height(slide_width);
        
      });
    }
    
    $(window).on('resize', function(){
      slide_height();
    });
    
    
  // Swatch functionality
    $('.cstm_card_wr').on('mouseenter', function(){
      var data_img = $(this).find('.var_price').children().first().attr('data-src');
      $(this).find('.card_media_main img').attr('srcset', data_img);
    });
    $('.var_img').on('mouseenter', function(){
      var data_img = $(this).attr('data-src');
      $(this).closest('.cstm_card_wr').find('.card_media_main img').attr('srcset', data_img);
    });

    $('.var_img').on('click', function(){
      var data_img_src = $(this).attr('data-src');
      $(this).closest('.cstm_card_wr').find('.card_media_hover .swiper-wrapper .swiper-slide-active img').attr('src', data_img_src);
      var data_img = $(this).addClass('active').siblings().removeClass('active');
      
      // url change on click
      var img_variant = $(this).parents('.cstm_card_wr').find('.var_price .var_img.active').attr('data-title');
      var size_variant = $(this).parents('.cstm_card_wr').find('.options_avl_1 .var_img.active').attr('data-value');
      var material_variant = $(this).parents('.cstm_card_wr').find('.options_avl_2 .var_img.active').attr('data-value');      

      
      if(img_variant != '' && size_variant != '' && material_variant == undefined){
        var fullVariant = size_variant + ' / ' + img_variant
      }
      if(img_variant == undefined && size_variant != '' && material_variant != ''){
        var fullVariant = size_variant + ' / ' + material_variant
      }
      if(img_variant == undefined && size_variant != '' && material_variant == undefined){
        var fullVariant = size_variant
      }
      if(img_variant != '' && size_variant == undefined && material_variant == undefined){
        var fullVariant = img_variant
      }
      // console.log(fullVariant);
      $(this).parents('.cstm_card_wr').find('.product-form__variants option').each(function(){
        var dataAttr = $(this).attr("data-title");
        if(fullVariant == dataAttr){
          // Changing price
          var data_price = $(this).attr("data-price");
          $(this).closest('.cstm_card_wr').find('span.var_img.price_var').text(data_price);
          // Changing url
          var data_variant_id = $(this).val();
          var slider_href = $(this).closest('.cstm_card_wr').find('.product-image a').attr('href');
          var split_url = slider_href.split('?');
          var final_url = split_url[0] + "?variant=" +data_variant_id;
          $(this).closest('.cstm_card_wr').find('.product-image a').attr('href', final_url);
        }
      });
    });
  }
  // hover_function();
  
  var dataId = $('.slideCollection').attr("data-value");
  var swiper = new Swiper(".slideCollection", {
    slidesPerView: dataId,
    spaceBetween: 30,
    navigation: {
      nextEl: ".paent_slider .swiper-button-next",
      prevEl: ".paent_slider .swiper-button-prev",
    },
    breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: dataId,
        
        },
    },
  });

  // Hotspot js
  $('.gs_hotspot_btn:not(.cstm_hotspot_product .gs_hotspot_btn)').on('click', function(){
    var data_value = $(this).attr('data-product-id');
    $(this).toggleClass('arrow_active').parents('.hotspot_btn_single').siblings().find('.gs_hotspot_btn').removeClass('arrow_active');
    // console.log(data_value);
      $('.product-grid').addClass('pop_main');
    $('.guineaDad .cstm_img_products ul.grid.product-grid li').each(function(){
       var data_id = $(this).attr('data-id');
       if(data_value == data_id){
         $(this).toggleClass('product_pop').siblings().removeClass('product_pop');;
       }
    });
  });


  // hotspot section js
  $(document).on('click', '.cstm_hotspot_product .gs_hotspot_btn', function(){
    var data_value = $(this).attr('data-product-id');
    $(this).parents('.hotspot_main').find('.gs_hotspot_btn').removeClass('arrow_active');
    $(this).addClass('arrow_active');
    // console.log(data_value);
    $('.guineaDad .cstm_img_products ul.grid.product-grid li').each(function(){
       var data_id = $(this).attr('data-id');
       if(data_value == data_id){
         $(this).addClass('active');
       }else{
         $(this).removeClass('active');
       }
    }); 
  });

  // Thumbnail slider
 if($(document).find('.cstm_vertical_slider')){
    var thumb_swiper = new Swiper('.cstm_vertical_slider .thumn_slider', {
    direction: 'vertical',
    mousewheel: true,
    autoScrollOffset: 1,
    spaceBetween: 20,
    slidesPerView: 5,
    navigation: {
      nextEl: ".thumn_slider .swiper-button-next",
      prevEl: ".thumn_slider .swiper-button-prev",
    }
  });
  }else{
     thumb_swiper.destroy();
  }

  // Product page thumb js
  if($('.cstm_vertical_slider').find('.thumbnail_media').length > 0){
    $('.cstm_vertical_slider').addClass('show_thumbnails');
  }

  // Main menu hover open menu js
  $('.header__inline-menu .list-menu li').on('mouseenter', function(){
    $(this).find('.header__menu-item').attr('aria-expanded', 'true');
     $(this).find('details').attr('open', true);
  });
    $('.header__inline-menu .list-menu li').on('mouseleave', function(){
    $(this).find('.header__menu-item').attr('aria-expanded', 'false');
     $(this).find('details').removeAttr('open');
  });

  // Image with text slider
    var swiper = new Swiper(".image_with_text_swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 400,
    effect: 'fade',
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  });

// image with slide height 
  $(window).on('resize', function(){
    slide_height();
  });
  slide_height();
  function slide_height(){
    var slide_width = $('.image_with_text_swiper .swiper-slide').width();
    $('.image_with_text_swiper .swiper-slide').height(slide_width);
  }

  // Menu title show hide
  $('.cstm_menu_text_main .cstm_menu_text').each(function(){
    var data_value = $(this).attr('data-value');
    var data_title = $(this).closest('.mega-menu').find('.header__menu-item').attr('data-title');
    if(data_title == data_value){
      $(this).show();
    }else{
      $(this).hide();
    }
  });
  
  // Frequently bought together 
   $('.check_main').on('change', function(){
      if($(this).is(':checked')){
        var data_variant = $(this).closest('.cstm_checkbox').find('.Custom_product option:selected').val();
        var data_price = $(this).closest('.cstm_checkbox').find('.Custom_product option:selected').attr('data-price');
        var data_selling_plan = $(this).closest('.cstm_checkbox').find('.selling_plan option:selected').val();
        
        $(this).closest('.cstm_checkbox').attr('data-variant', data_variant);
        $(this).closest('.cstm_checkbox').attr('data-price', data_price);
        $(this).closest('.cstm_checkbox').attr('data-selling-plan', data_selling_plan); 
        
      }else{
        
        $(this).closest('.cstm_checkbox').attr('data-variant', '');
        $(this).closest('.cstm_checkbox').attr('data-price', ''); 
        $(this).closest('.cstm_checkbox').attr('data-selling-plan', ''); 
        
      }
      var total = 0;
      $('.main_info .cstm_checkbox').each(function(){
        if($(this).attr('data-price') != ''){
          var data_price = $(this).attr('data-price');
          var data_price = data_price.replace(/,/g, '');
          total += parseFloat(data_price);
        }
      });
      var total = total.toLocaleString();
      $('.main_price').text(total);
     });
  
  // on selling plan change price and id change
    $('.selling_plan').on('change', function(){
      var checked_check = $(this).closest('.cstm_checkbox').find('.check_main');
       if(checked_check.is(':checked')){
        var data_selling_plan = $(this).closest('.cstm_checkbox').find('.selling_plan option:selected').val();
        var data_selling_price = $(this).closest('.cstm_checkbox').find('.selling_plan option:selected').attr('data-selling-price');
         // console.log(data_selling_price);
        $(this).closest('.cstm_checkbox').attr('data-selling-plan', data_selling_plan);
        $(this).closest('.cstm_checkbox').attr('data-price', data_selling_price);
        price_update();
       }
        
        var main_price_value = $('.main_price').text();
        var comp_price_value = $('.comp_price').text();
        if (main_price_value == comp_price_value){
          $('.comp_del').hide();
        }else{
          $('.comp_del').show();
        }
    });
  
  // Show total product price
  price_update();
  function price_update(){
    var total = 0;
    $('.main_info .cstm_checkbox').each(function(){
      if($(this).attr('data-price') != ''){
        var data_price = $(this).attr('data-price');
        var data_price = data_price.replace(/,/g, '');
        total += parseFloat(data_price);
      }
      var data_selling_plan = $(this).closest('.cstm_checkbox').find('.selling_plan option:selected').val();
      $(this).attr('data-selling-plan', data_selling_plan);
    });
    var total = total.toLocaleString();
    $('.main_price').text(total);
  }

  // Compare price show
    comp_price_update();
  function comp_price_update(){
    var total = 0;
    $('.main_info .cstm_checkbox').each(function(){
      if($(this).attr('data-one-time-price') != ''){
        var data_price = $(this).attr('data-one-time-price');
        var data_price = data_price.replace(/,/g, '');
        total += parseFloat(data_price);
      }
      
    });
    var total = total.toLocaleString();
    $('.comp_price').text(total);
  }

  
  // Adding products to cart
    $('.atc_button').on('click', function(){
      
      Shopify.queue = [];
    
      var rawItems = $('.main_info .cstm_checkbox');
      
      $(rawItems).each(function() {
        if($(this).attr('data-variant') != ''){
          if ($.isNumeric($(this).attr('data-selling-plan'))){
            var selling_plan = $(this).attr('data-selling-plan')
          }
          Shopify.queue.push({
            variantId: $(this).attr('data-variant'),
            quantity: 1,
            selling_plan: selling_plan
          });
        }
      });
      
      Shopify.addItem = function(id, qty, selling_plan, callback) {
        var params = {
          quantity: qty,
          id: id,
          selling_plan: selling_plan
        };
   
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: params,
          success: function(){
            if(typeof callback === 'function'){
              callback();
            }
          },
          error: function(){}
        });
      }
      
      Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          Shopify.addItem(request.variantId, request.quantity, request.selling_plan, Shopify.moveAlong);
        }
        // If the queue is empty, we will redirect to the cart page.
        else {
          // document.location.href = '/cart';
        }
      };
     
      Shopify.moveAlong();
        
    });

  // collection page select change redirect
  $('.cstm_facet .facet-filters__sort').on('change', function(){
    var sel_value = $(this).find('option:selected').val();
    if(sel_value == 'bunny_pig'){
      location.href = "/collections/bunnydad-all-products"
    }else if(sel_value == 'guinea_pig'){
      location.href = "/collections/all-guinea-pig-products"
    }
  });
  //Infinite Scroll collection page
  var scroll_enable = $('#product-grid').attr('data-scroll');
  if(scroll_enable == 'enabled'){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#infinite-Pagination',
      loadingText: 'Loading...',
      offset: 1000,
      // callback: hover_function
    });
  }

  // Color swatch name js
    var input_Color = $("input[name='Color']:checked").val();
    $("input[name='Color']").closest('.product-form__input').find('.sel_variant').text(input_Color);
  
    $('.cstm_input').on('change', function(){
       var input_name = $(this).attr('name');
      var input_Color = $("input[name='" +input_name+ "']:checked").val();
      $(this).closest('.product-form__input').find('.sel_variant').text(input_Color);
    });
  // Product page accordian first open
    $('.cstm_gallery_accord .product__accordion:first-of-type').find("details").attr('open', true).find('summary').attr('aria-expanded', true);



  var check_pro_load = $(document).find("#find_subscription").val();
     if(check_pro_load == 'subscription'){
       $(document).find('input:radio[name="paywhirl-plan-selector-group"]').each(function (){
          var radioVal = $(this).val();
          if(radioVal != ''){
            $(this).click();
          }
       });
     }
      if(check_pro_load == 'onetime'){
       $(document).find(".paywhirl-plan-selector .paywhirl-plan-selector-plan>select").hide();
       $(document).find('input:radio[name="paywhirl-plan-selector-group"]').each(function (){
          var radioVal = $(this).val();
          if(radioVal == ''){
            $(this).click();
          }
       });
     }

  // Subscription product functionality
  $(document).on("click",".paywhirl-plan-selector-group-container label",function() {
      setTimeout(function() {
         var checkval = $(document).find("input[name='selling_plan']").val();
         var check_pro = $(document).find("#find_subscription").val();
         var data_onetime = $(document).find("#find_subscription").attr('data-onetime');
         var data_subscription = $(document).find("#find_subscription").attr('data-subscription');
         if(check_pro == 'onetime'){
           if(checkval != ''){
             var new_url = '/products/'+data_subscription;
             window.location.assign(new_url);
           }
         }
         if(check_pro == 'subscription'){
           if(checkval == ''){
             var new_url = '/products/'+data_onetime;
             window.location.assign(new_url);
           }
         }
      }, 500);
   });

 // Popup js
  $(document).on("click", ".popup_trigger", function (e) {
    e.preventDefault();
    if($(this).next(".itg_popup_wr").length){
      $(this).next(".itg_popup_wr").addClass("visible");
      $("body").css("overflow", "hidden");
    }
  });
  $(document).on("click", ".itg_popup_overlay, .itg_close_btn", function () {
    $(".itg_popup_wr").removeClass("visible");
    $("body").css("overflow", "auto");
  });
  if($('.thumn_slider .swiper-button').hasClass('swiper-button-lock')){
    $('.thumn_slider').css('padding', '0');
  }

  // blog filter js
  document.addEventListener('click', function(event) {
    // Get all details elements
    var detailsElements = document.querySelectorAll('details');
    
    // Loop through each details element
    detailsElements.forEach(function(details) {
      // If the clicked element is not inside the current details element
      if (!details.contains(event.target) || event.target.tagName == 'A') {
        // Close the details element
        details.removeAttribute('open');
      }
    });
  });

  // 
  
if(location.pathname.includes('guineadad-blogs') || location.pathname.includes('blogs/news')){
  if($('.category_one').length > 0){
   var guinea_text = $('.category_one .filter_values').find('.blog_filters_single:first-child a').text();
    $('.category_one').find('.cat_value').text(guinea_text);
  }
  
}
  if(location.pathname.includes('bunnydad-blogs')){
    if($('.category_one').length > 0){
     var guinea_text = $('.category_one .filter_values').find('.blog_filters_single:nth-child(2) a').text();
      $('.category_one').find('.cat_value').text(guinea_text);
    }
  }

});

